<template>
    <div class="call-button-container">
        <woot-button
            v-tooltip="$t('CONVERSATION.CALL_RINGING')"
            color-scheme="success"
            class-names="shake glow-border glow-green"
            :size="size"
            icon="telephone"
            @click="telephone"
        />
    </div>
</template>

<script>
export default {
  name: 'CallButton',
  props: {
    currentChat: {
      type: Object,
      required: true
    },
    size: {
      type: String,
      default: ''
    },
    origin: {
      type: String,
      default: 'chat', // chat or list
    }
  },
  methods: {
    telephone() {
      window.bus.$emit('open-call-modal', {
        conversationId: this.currentChat.id,
        origin: this.origin,
        element: this.$el,
      });
    }
  }
};
</script>

<style scoped lang="scss">
.call-button-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
@keyframes shake {
  0%   { transform: translateX(0); }
  20%  { transform: translateX(-3px); }
  40%  { transform: translateX(3px); }
  60%  { transform: translateX(-3px); }
  80%  { transform: translateX(3px); }
  100% { transform: translateX(0); }
}

@keyframes subtle-border-glow {
  0%   { box-shadow: 0 0 1px rgba(0, 255, 21, 0.3); }
  50%  { box-shadow: 0 0 4px rgba(0, 255, 21, 0.7); }
  100% { box-shadow: 0 0 1px rgba(0, 255, 21, 0.3); }
}

@keyframes glow {
  0%, 100% { color: rgba(255, 255, 255, 0.7); }
  50%      { color: rgba(255, 255, 255, 1); }
}

.shake {
  animation: shake 0.15s linear infinite; /* Vibração contínua */
}

.glow-border {
  border: 1px solid rgba(0, 255, 42, 0.7);
  border-radius: 6px;
  animation: subtle-border-glow 1.2s infinite ease-in-out;
}

.glow-green {
  animation: glow 1.2s infinite ease-in-out;
}
</style>